import { useEffect }    from 'react';
import { connect }      from 'react-redux';
// Redux
import {getNotifications}   from '../../redux/actions/Notifications';
// Components
import Head         from '../global/Head';
import Tables       from './Tables';
import Form         from './Form';
// Values
import {StateView}  from '../../values';
// Api
import {getData}    from '../../utils/notifications';

const Index = ({stateView, token, getNotifications}) => {
    const GetData = async() =>{
        const res = await getData(token)
        getNotifications(res.data)
    }
    useEffect(() =>{
        if(token){
            if(stateView === StateView.state1){
                GetData()
            }
        }
    })
    return (
        <div>
            <Head title='Notificaciones' />
            {
                stateView===StateView.state1?
                    <Tables />
                :
                    <Form />
            }
        </div>
    );
};

const mapStateToProps = state =>({
    stateView:      state.View.stateView,
    token:          state.Panel.token
})

export default connect(mapStateToProps, {getNotifications})(Index);
